import { redirect } from "@tanstack/react-router";

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUUID(value: string): boolean {
  return UUID_REGEX.test(value);
}

export function buildOrgPath(
  organizationBusinessUnitId: string,
  subPath: string,
): string {
  if (!organizationBusinessUnitId) {
    return `/org${subPath}`;
  }
  return `/org/bu/${organizationBusinessUnitId}${subPath}`;
}

export function createOrgRedirect(newRoute: string) {
  return {
    beforeLoad: ({
      context,
    }: {
      context: { savedOrgBusinessUnit?: { id: string } };
    }) => {
      const organizationBusinessUnitId = context.savedOrgBusinessUnit?.id;
      if (!organizationBusinessUnitId) {
        throw redirect({ to: "/org/providers" });
      }
      throw redirect({
        to: newRoute,
        params: { organizationBusinessUnitId },
      });
    },
  };
}

export function createOrgRedirectWithParams(
  newRoute: string,
  paramNames: string[],
) {
  return {
    beforeLoad: ({
      context,
      params,
    }: {
      context: { savedOrgBusinessUnit?: { id: string } };
      params: Record<string, string>;
    }) => {
      const organizationBusinessUnitId = context.savedOrgBusinessUnit?.id;
      if (!organizationBusinessUnitId) {
        throw redirect({ to: "/org/providers" });
      }
      throw redirect({
        to: newRoute,
        params: {
          organizationBusinessUnitId,
          ...Object.fromEntries(paramNames.map((n) => [n, params[n]])),
        },
      });
    },
  };
}
